import React from 'react';
import { Card, CardContent, Typography, CardActionArea, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { School as SchoolIcon, ChevronRight as ChevronRightIcon, ChevronLeft as ChevronLeftIcon } from '@mui/icons-material';
import { useLanguage } from '../contexts/LanguageContext';

const DepartmentCard = ({ department, universityId, lecturerCount = 0 }) => {
  const { t, isArabic } = useLanguage();

  if (!department) {
    return null;
  }

  return (
    <Card 
      elevation={0}
      sx={{ 
        height: '100%',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 3,
        transition: 'all 0.2s ease-in-out',
        bgcolor: 'white',
        '&:hover': { 
          borderColor: 'primary.light',
          boxShadow: '0 4px 20px rgba(30, 58, 138, 0.1)',
          transform: 'translateY(-2px)',
          '& .arrow-icon': {
            opacity: 1,
            transform: isArabic ? 'translateX(-4px)' : 'translateX(4px)',
          },
        }
      }}
    >
      <CardActionArea 
        component={Link} 
        to={`/university/${universityId}/department/${department.id}`}
        sx={{ height: '100%' }}
      >
        <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <SchoolIcon sx={{ color: 'white', fontSize: 22 }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography 
                variant="subtitle1" 
                sx={{ 
                  fontWeight: 600,
                  lineHeight: 1.3,
                  fontSize: '0.95rem',
                  color: 'text.primary',
                  mb: 0.5,
                }}
              >
                {department.name}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ fontSize: '0.8rem' }}
              >
                {lecturerCount} {t('lecturers', 'محاضر')}
              </Typography>
            </Box>
            <Box
              className="arrow-icon"
              sx={{
                display: 'flex',
                alignItems: 'center',
                opacity: 0,
                transition: 'all 0.2s ease-in-out',
                color: 'primary.main',
              }}
            >
              {isArabic ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </Box>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default DepartmentCard;
